export default class NotesModal {
  constructor () {
    this.modalElement = document.getElementById('notes-modal')
    this.saveBtnElement = document.getElementById('nm-save')
    this.cancelBtnElement = document.getElementById('nm-cancel')
    this.deleteBtnElement = document.getElementById('nm-delete')
    this.editBtnElement = document.getElementById('nm-edit')
    this.textareaElement = document.getElementById('nm-editor')
    this.noteElement = document.getElementById('nm-note')
    this.editWrap = document.getElementById('nm-edit-wrap')
    this.displayWrap = document.getElementById('nm-display-wrap')

    this.onsave = null;
    this.ondelete = null;

    this.modalOpened = false
    this.hiddenClass = 'hidden'

    this._reset()

    this._bindEvents()
  }

  _reset () {
    this.x = 0
    this.y = 0
    this.text = ''
    this.isEditing = false
    this.modalElement.classList.add(this.hiddenClass)
    this.payload = {}
    this.textareaElement.value = ''
    this.noteElement.innerText = ''
  }

  _bindEvents () {
    this.textareaElement.addEventListener('keyup', evt => this._onTextareaKeyUp(evt))
    this.saveBtnElement.addEventListener('click', evt => this._onSaveClick(evt))
    this.cancelBtnElement.addEventListener('click', evt => this._onCancelClick(evt))
    this.editBtnElement.addEventListener('click', evt => this._onEditClick(evt))
    this.deleteBtnElement.addEventListener('click', evt => this._onDeleteClick(evt))
  }

  _onTextareaKeyUp (evt) {
    if (evt.keyCode == 13) {
      this._onSaveClick()
    }

    if (evt.keyCode == 27) {
      this._onCancelClick()
    }
  }

  _onSaveClick () {
    this.text = this.textareaElement.value
    this.close()

    if (this.onsave) {
      this.onsave({
        text: this.text,
        ...this.payload
      })
    }

    this._reset()
  }

  _onCancelClick () {
    this.close()
  }

  _onDeleteClick () {
    this.close()

    if (this.ondelete) {
      this.ondelete(this.payload)
    }

    this._reset()
  }

  _onEditClick () {
    this._editMode()
  }

  open () {
    this.modalOpened = true
    this.modalElement.classList.remove(this.hiddenClass)
    return this
  }

  close () {
    this.modalOpened = false
    this.modalElement.classList.add(this.hiddenClass)
    return this
  }

  isOpened () {
    return this.modalOpened
  }

  isEditing () {
    return this.isEditing
  }

  at (x, y) {
    this.x = x - (300/2)
    this.y = y - (104)
    this._updateStyleAttribute()
    return this
  }

  withPayload (payload) {
    this.payload = {...payload}
    return this
  }

  withText (text) {
    this.text = text
    this.textareaElement.value = text
    this.noteElement.innerText = text
    return this
  }

  edit () {
    this._editMode()
    return this
  }

  display () {
    this._displayMode()
    return this
  }

  _editMode () {
    this.editWrap.classList.remove('hidden')
    this.displayWrap.classList.add('hidden')
    this.open()
    this.isEditing = true
    this.textareaElement.focus()
  }

  _displayMode () {
    this.editWrap.classList.add('hidden')
    this.displayWrap.classList.remove('hidden')
    this.open()
    this.isEditing = false
  }

  _updateStyleAttribute () {
    this.modalElement.setAttribute('style', `top: ${this.y}px; left: ${this.x}px;`)
  }
}
